import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { ArtefactType } from '@modules/common/types';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { MoveToInboxRounded } from '@mui/icons-material';
import {
  Box,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Tooltip,
} from '@mui/material';
import { useGetUser } from 'v2/core/services/user';
import { ArchiveDashboardForm } from '../ArchiveDashboardForm';

interface ArchiveDashboardMenuItemProps {
  closeMenu: () => void;
}

export const ArchiveDashboardMenuItem = ({
  closeMenu,
}: ArchiveDashboardMenuItemProps) => {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);

  const { openModal } = useMuiModalContext();

  const { pinnedDashboards = [] } = useGetUser();

  const isPinnedDashboard = pinnedDashboards.some(
    (pinnedDashboard) => pinnedDashboard.id === dashboard.id,
  );

  const archiveDashboard = () => {
    openModal({
      contentComponent: () => (
        <ArchiveDashboardForm
          dashboard={dashboard}
          dashboardType={ArtefactType.Dashboard}
        />
      ),
      modalProps: {
        fullWidth: true,
        maxWidth: 'sm',
      },
    });
    closeMenu();
  };

  const renderArchiveDashboardMenuItem = () => (
    <MenuItem onClick={archiveDashboard} disabled={isPinnedDashboard}>
      <ListItemIcon>
        <MoveToInboxRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>Archive Dashboard</ListItemText>
    </MenuItem>
  );

  if (isPinnedDashboard) {
    return (
      <Tooltip title="Please unpin this dashboard to archive" placement="left">
        <Box>{renderArchiveDashboardMenuItem()}</Box>
      </Tooltip>
    );
  }

  return renderArchiveDashboardMenuItem();
};
